import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

const Checkbox = ({ status = false, checkId, title, changeHandle }) => {

    useEffect(() => { status && changeHandle({ target: { name: checkId, checked: status, value: checkId } }) }, []);
    
    return (
        <Form.Check type="checkbox" label={ title } name={ checkId } checked={ status } value={ checkId } className='form-checkbox' onChange={ changeHandle } />
    );
};

export default React.memo(Checkbox);
